import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { mainServiceURL } from "./defines";

export interface CreateOnboardingRequest {
  email: string;
}

export interface CompleteRegistrationRequest {
  token: string;
  data: {
    user: {
      firstName: string;
      lastName: string;
      password: string;
    };
    company: {
      name: string;
    };
  };
}

export const onboardingApi = createApi({
  reducerPath: "onboardingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: mainServiceURL,
    credentials: "include",
  }),
  endpoints: (builder) => ({
    register: builder.mutation<void, CreateOnboardingRequest>({
      query: (data) => ({
        url: "/onboarding/register",
        method: "POST",
        body: data,
      }),
    }),
    createAccount: builder.mutation<any, CompleteRegistrationRequest>({
      query: ({ data, token }) => ({
        url: "/onboarding/create-account",
        method: "POST",
        body: { ...data, token },
      }),
    }),
  }),
});

export const { useRegisterMutation, useCreateAccountMutation } = onboardingApi;
